import { a as he, b as Ge } from "./chunk-GSUMVHQC.js";
import { a as Ee, b as Ae } from "./chunk-65GVFYLQ.js";
import { a as ye, b as ce } from "./chunk-6F2M3SVY.js";
import { a as De, b as Ce } from "./chunk-MFN5LMXX.js";
import { a as Me, b as Re } from "./chunk-M6PBA2JL.js";
import { a as Se, b as Be } from "./chunk-62ULHJU5.js";
import { a as He, b as Ue } from "./chunk-HWWCESCD.js";
import { a as Fe, b as Te } from "./chunk-2RP4XPBM.js";
import { a as Ze, b as Ie } from "./chunk-KL5KYZQ3.js";
import { a as fe } from "./chunk-ODJCLU6C.js";
import { a as ae, b as te } from "./chunk-CRRZV4QY.js";
import { a as oe } from "./chunk-WFBH3POG.js";
import { a as me, b as pe } from "./chunk-V6ZNXXBW.js";
import { a as ke, b as se } from "./chunk-G7EKEWC4.js";
import { a as ie, b as _e } from "./chunk-OIPJBL2E.js";
import { a as ne, b as xe } from "./chunk-AADLYGNU.js";
import { a as le, b as de } from "./chunk-ZDEMDSU5.js";
import { a as ue, b as Ne } from "./chunk-HSM4IAE7.js";
import { a as Pr, b as br } from "./chunk-LE7GYDYM.js";
import { a as vr, b as gr } from "./chunk-DCIPQAGA.js";
import { a as Vr, b as Wr } from "./chunk-KXZQPPLI.js";
import { a as wr } from "./chunk-KQAFWHAH.js";
import { a as Xr, b as jr } from "./chunk-2KJKGUBI.js";
import { a as Yr } from "./chunk-BVTGCSSB.js";
import { a as Jr, b as qr } from "./chunk-JV4XND7U.js";
import { a as Qr, b as $r } from "./chunk-SETEPUM7.js";
import { a as re, b as ee } from "./chunk-A3NYXYG2.js";
import { a as Mr, b as Rr } from "./chunk-XDVH72IE.js";
import { a as Sr, b as Br } from "./chunk-IEGMIHOY.js";
import { a as Hr, b as Ur } from "./chunk-J2NF3XHN.js";
import { a as Fr, b as Tr } from "./chunk-EBYYFVUQ.js";
import { a as Zr, b as Ir } from "./chunk-AMRABQXE.js";
import { a as hr, b as Gr } from "./chunk-PPW6DBMJ.js";
import { a as Lr, b as Or } from "./chunk-XZILJKWX.js";
import { a as Kr, b as zr } from "./chunk-GRIQR6LW.js";
import { a as sr } from "./chunk-JOSVYWZC.js";
import { a as ir, b as _r } from "./chunk-DHE7OUCT.js";
import { a as nr, b as xr } from "./chunk-6XT4WTUR.js";
import { a as lr, b as dr } from "./chunk-NTFZXEBY.js";
import { a as ur, b as Nr } from "./chunk-UZR566TR.js";
import { a as Er, b as Ar } from "./chunk-GI7YTZOQ.js";
import { a as kr } from "./chunk-BKUYYLI4.js";
import { a as yr, b as cr } from "./chunk-HB4YG6TV.js";
import { a as Dr, b as Cr } from "./chunk-Y55LL5WI.js";
import { a as Y, b as w } from "./chunk-Y5YCABX2.js";
import { a as X, b as j } from "./chunk-LIZRYTNX.js";
import { a as J, b as q } from "./chunk-Z54DZR3H.js";
import { a as Q, b as $ } from "./chunk-OUKKOV4G.js";
import { a as er } from "./chunk-TYOUK4VV.js";
import { a as or, b as fr } from "./chunk-ZQUKORAE.js";
import { a as rr } from "./chunk-7TT5MNTH.js";
import { a as ar, b as tr } from "./chunk-4LDGX3KC.js";
import { a as mr, b as pr } from "./chunk-EJXOTFHE.js";
import { a as F, b as T } from "./chunk-6I4K6CB2.js";
import { a as Z, b as I } from "./chunk-5G2WVKP7.js";
import { a as h, b as G } from "./chunk-YM32AL7T.js";
import { a as L, b as O } from "./chunk-IB7YBCBW.js";
import { a as K, b as z } from "./chunk-UQHWFMAP.js";
import { a as P, b } from "./chunk-K6GZVCHP.js";
import { a as v, b as g } from "./chunk-5GKUZVST.js";
import { a as V, b as W } from "./chunk-7JZUFJWF.js";
import { a as u, b as N } from "./chunk-MUELD3OP.js";
import { a as A } from "./chunk-XSZGRW3J.js";
import { a as y, b as c } from "./chunk-ZTCY2M2J.js";
import { a as D, b as C } from "./chunk-C36YYUQB.js";
import { a as E } from "./chunk-RCCYSHWF.js";
import { a as M, b as R } from "./chunk-3XHWC7DR.js";
import { a as S, b as B } from "./chunk-INAUBF2M.js";
import { a as r } from "./chunk-TVFJBHBT.js";
import { a as U } from "./chunk-DRI4RH7F.js";
import { a as H } from "./chunk-QA3QK7DB.js";
import { a as e, b as a } from "./chunk-XC4DGQLO.js";
import { a as t, b as m } from "./chunk-VY5QKEJD.js";
import { a as p, b as k } from "./chunk-3ANZR66A.js";
import { a as s } from "./chunk-TIGVPJWT.js";
import { a as i, b as _ } from "./chunk-YD7RMVQK.js";
import { a as n, b as x } from "./chunk-T4PY3YXT.js";
import { a as l, b as d } from "./chunk-7VNNBN5B.js";
import { a as f } from "./chunk-KERBADJJ.js";
import { a as Le, b as Oe, c as Ke, d as ze, e as Pe, f as be, g as ve, h as ge, i as Ve, j as We, k as Ye, l as we, m as Xe, n as je, o } from "./chunk-PC2QB7VM.js";
var uf = {
  af_ZA: a,
  ar: m,
  az: k,
  base: s,
  bn_BD: _,
  cs_CZ: x,
  cy: d,
  da: N,
  de: A,
  de_AT: c,
  de_CH: C,
  dv: R,
  el: B,
  en: r,
  en_AU: U,
  en_AU_ocker: T,
  en_BORK: I,
  en_CA: G,
  en_GB: O,
  en_GH: z,
  en_HK: b,
  en_IE: g,
  en_IN: W,
  en_NG: w,
  en_US: j,
  en_ZA: q,
  eo: $,
  es: er,
  es_MX: fr,
  fa: tr,
  fi: pr,
  fr: sr,
  fr_BE: _r,
  fr_CA: xr,
  fr_CH: dr,
  fr_LU: Nr,
  fr_SN: Ar,
  he: cr,
  hr: Cr,
  hu: Rr,
  hy: Br,
  id_ID: Ur,
  it: Tr,
  ja: Ir,
  ka_GE: Gr,
  ko: Or,
  lv: zr,
  mk: br,
  nb_NO: gr,
  ne: Wr,
  nl: wr,
  nl_BE: jr,
  pl: qr,
  pt_BR: $r,
  pt_PT: ee,
  ro: fe,
  ro_MD: te,
  ru: pe,
  sk: se,
  sr_RS_latin: _e,
  sv: xe,
  ta_IN: de,
  th: Ne,
  tr: Ae,
  uk: ce,
  ur: Ce,
  uz_UZ_latin: Re,
  vi: Be,
  yo_NG: Ue,
  zh_CN: Te,
  zh_TW: Ie,
  zu_ZA: Ge
};
var rm = {
  af_ZA: e,
  ar: t,
  az: p,
  base: o,
  bn_BD: i,
  cs_CZ: n,
  cy: l,
  da: u,
  de: E,
  de_AT: y,
  de_CH: D,
  dv: M,
  el: S,
  en: f,
  en_AU: H,
  en_AU_ocker: F,
  en_BORK: Z,
  en_CA: h,
  en_GB: L,
  en_GH: K,
  en_HK: P,
  en_IE: v,
  en_IN: V,
  en_NG: Y,
  en_US: X,
  en_ZA: J,
  eo: Q,
  es: rr,
  es_MX: or,
  fa: ar,
  fi: mr,
  fr: kr,
  fr_BE: ir,
  fr_CA: nr,
  fr_CH: lr,
  fr_LU: ur,
  fr_SN: Er,
  he: yr,
  hr: Dr,
  hu: Mr,
  hy: Sr,
  id_ID: Hr,
  it: Fr,
  ja: Zr,
  ka_GE: hr,
  ko: Lr,
  lv: Kr,
  mk: Pr,
  nb_NO: vr,
  ne: Vr,
  nl: Yr,
  nl_BE: Xr,
  pl: Jr,
  pt_BR: Qr,
  pt_PT: re,
  ro: oe,
  ro_MD: ae,
  ru: me,
  sk: ke,
  sr_RS_latin: ie,
  sv: ne,
  ta_IN: le,
  th: ue,
  tr: Ee,
  uk: ye,
  ur: De,
  uz_UZ_latin: Me,
  vi: Se,
  yo_NG: He,
  zh_CN: Fe,
  zh_TW: Ze,
  zu_ZA: he
};
export { Oe as Aircraft, Pe as BitcoinAddressFamily, be as BitcoinNetwork, ze as CssFunction, Ke as CssSpace, je as Faker, Le as FakerError, ve as IPv4Network, ge as Sex, Ye as SimpleFaker, e as af_ZA, uf as allFakers, rm as allLocales, t as ar, p as az, o as base, i as bn_BD, n as cs_CZ, l as cy, u as da, E as de, y as de_AT, D as de_CH, M as dv, S as el, f as en, H as en_AU, F as en_AU_ocker, Z as en_BORK, h as en_CA, L as en_GB, K as en_GH, P as en_HK, v as en_IE, V as en_IN, Y as en_NG, X as en_US, J as en_ZA, Q as eo, rr as es, or as es_MX, ar as fa, r as faker, a as fakerAF_ZA, m as fakerAR, k as fakerAZ, s as fakerBASE, _ as fakerBN_BD, x as fakerCS_CZ, d as fakerCY, N as fakerDA, A as fakerDE, c as fakerDE_AT, C as fakerDE_CH, R as fakerDV, B as fakerEL, r as fakerEN, U as fakerEN_AU, T as fakerEN_AU_ocker, I as fakerEN_BORK, G as fakerEN_CA, O as fakerEN_GB, z as fakerEN_GH, b as fakerEN_HK, g as fakerEN_IE, W as fakerEN_IN, w as fakerEN_NG, j as fakerEN_US, q as fakerEN_ZA, $ as fakerEO, er as fakerES, fr as fakerES_MX, tr as fakerFA, pr as fakerFI, sr as fakerFR, _r as fakerFR_BE, xr as fakerFR_CA, dr as fakerFR_CH, Nr as fakerFR_LU, Ar as fakerFR_SN, cr as fakerHE, Cr as fakerHR, Rr as fakerHU, Br as fakerHY, Ur as fakerID_ID, Tr as fakerIT, Ir as fakerJA, Gr as fakerKA_GE, Or as fakerKO, zr as fakerLV, br as fakerMK, gr as fakerNB_NO, Wr as fakerNE, wr as fakerNL, jr as fakerNL_BE, qr as fakerPL, $r as fakerPT_BR, ee as fakerPT_PT, fe as fakerRO, te as fakerRO_MD, pe as fakerRU, se as fakerSK, _e as fakerSR_RS_latin, xe as fakerSV, de as fakerTA_IN, Ne as fakerTH, Ae as fakerTR, ce as fakerUK, Ce as fakerUR, Re as fakerUZ_UZ_latin, Be as fakerVI, Ue as fakerYO_NG, Te as fakerZH_CN, Ie as fakerZH_TW, Ge as fakerZU_ZA, mr as fi, kr as fr, ir as fr_BE, nr as fr_CA, lr as fr_CH, ur as fr_LU, Er as fr_SN, Ve as generateMersenne32Randomizer, We as generateMersenne53Randomizer, yr as he, Dr as hr, Mr as hu, Sr as hy, Hr as id_ID, Fr as it, Zr as ja, hr as ka_GE, Lr as ko, Kr as lv, Xe as mergeLocales, Pr as mk, vr as nb_NO, Vr as ne, Yr as nl, Xr as nl_BE, Jr as pl, Qr as pt_BR, re as pt_PT, oe as ro, ae as ro_MD, me as ru, we as simpleFaker, ke as sk, ie as sr_RS_latin, ne as sv, le as ta_IN, ue as th, Ee as tr, ye as uk, De as ur, Me as uz_UZ_latin, Se as vi, He as yo_NG, Fe as zh_CN, Ze as zh_TW, he as zu_ZA };